
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/company_vendors",
      function () {
        return require("private-next-pages/settings/company_vendors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/company_vendors"])
      });
    }
  